import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";

export type User = {
  [index: string]: any;
  nom: string;
  prenom?: string;
  telephone: string;
  adresse: string;
  email?: string;
  codeParrainage?: string;
};

type Credentials = {
  telephone: string;
  pin: string;
};

export declare interface AuthState {
  user: User | null;
}
const initialState: AuthState = {
  user: null,
};

export const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    createAuth: (state, action) => {
      state.user = action.payload;
      return state;
    },
    updateAuth: (state, action) => {
      state.user = action.payload;
      return state;
    },
  },
});

export const { createAuth, updateAuth } = authSlice.actions;

export const asyncSignin =
  (
    credentials: Credentials,
    callback: Callback,
    badCredentialsError: Callback,
    onError: Callback
  ) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const result = await fetch(`${SERVER_URL}login`, {
        method: "POST",
        body: JSON.stringify(credentials),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (result.status !== 200) {
        badCredentialsError?.();
      } else {
        const user = await result.json()
        dispatch(createAuth(user))
        // console.log("###result###", await result.json());
        callback?.();
      }
    } catch (error) {
      console.log("sign in error", error);
      onError?.();
    }
  };

export default authSlice.reducer as Reducer<AuthState>;
